/**
 * Global live-reload interval for all analytics queries.
 *
 * The QueryClient default `refetchInterval` reads `getRefreshInterval()`, so a
 * single module-level setting drives background polling for every panel (LAW +
 * GA4) — stable query keys, no loading flash. The toolbar updates it via
 * `setRefreshInterval(...)` and then triggers one refetch so observers
 * reschedule immediately (TanStack re-evaluates `refetchInterval` after a fetch).
 *
 * Kept dependency-free (no queryClient import) to avoid a cycle with query-client.
 */

/** Selectable intervals (ms). `false` = off. */
export const REFRESH_OPTIONS: Array<{ label: string; value: number | false }> = [
  { label: "Off", value: false },
  { label: "30s", value: 30_000 },
  { label: "1m", value: 60_000 },
  { label: "5m", value: 300_000 },
];

/** Default live-reload cadence. */
export const DEFAULT_REFRESH_INTERVAL: number | false = 60_000;

let current: number | false = DEFAULT_REFRESH_INTERVAL;

export function getRefreshInterval(): number | false {
  return current;
}

export function setRefreshInterval(ms: number | false): void {
  current = ms;
}
